import { captureSentryError } from '@vrplatform/data';
import { useEffect } from 'react';

export const useLegacyServiceWorkerCleanup = () => {
  useEffect(() => {
    if (!('serviceWorker' in navigator) && !('caches' in globalThis)) return;

    void (async () => {
      let removedLegacyServiceWorker = false;

      if ('serviceWorker' in navigator) {
        const legacyRegistrations = (
          await navigator.serviceWorker.getRegistrations()
        ).filter((registration) =>
          [
            registration.active,
            registration.installing,
            registration.waiting,
          ].some((worker) => worker?.scriptURL.endsWith('/sw.js'))
        );

        removedLegacyServiceWorker = legacyRegistrations.length > 0;
        await Promise.all(
          legacyRegistrations.map((registration) => registration.unregister())
        );
      }

      if ('caches' in globalThis && removedLegacyServiceWorker) {
        await Promise.all(
          (await caches.keys()).map((cacheKey) => caches.delete(cacheKey))
        );
      }
    })().catch((error: unknown) => {
      captureSentryError(error, {
        level: 'error',
        fingerprint: ['legacy-service-worker-cleanup'],
      });
    });
  }, []);
};
